import React from "react";
import ReactQuill from "react-quill";
import email_icon_Form from "../../Assets/email_icon_Form.svg";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";
const EmailQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="nameAns_container">
        <div className="Name" style={{ display: "flex", gap: "0.5rem" }}>
          <img src={email_icon_Form} alt="email_icon_Form" />
          {question.placeHolder}
        </div>
      </div>
    </>
  );
};

export default EmailQuestion;
